import {
  getSegmentList,
  putUpdateStatusSegment,
  postCreateSegmentGroup,
  getSegmentGroupList,
  putUpdateStatusSegmentGroup,
  deleteSegment,
  deleteSegmentGroup,
  getSegmentGroupAB,
  putUpdateStatusSegmentGroupAB,
  deleteSegmentGroupAB,
  putUpdateSegmentGroup,
} from 'features/Segmentation/services/segment'
import type {
  DeleteSegmentGroupABRequestType,
  PutUpdateStatusSegmentGroupABRequestType,
  DeleteSegmentGroupRequestType,
  DeleteSegmentRequestType,
  PutUpdateStatusSegmentGroupRequestType,
  PostCreateSegmentGroupRequestType,
  PutUpdateStatusSegmentRequestType,
  GetSegmentListRequestType,
  PutUpdateSegmentGroupType,
} from 'features/Segmentation/services/segment'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { callErrorMsg } from 'helpers/errorMsg'

import { toastSuccess } from 'utils/toast'
import {
  SLICE_NAME,
  setIsLoading,
  setQuery,
  setSegments,
  setSegmentGroups,
  setSegmentGroupsAB,
} from './slice'

export const fetchSegmentList = createAsyncThunk(
  `${SLICE_NAME}/fetchSegmentList`,
  async (_, { dispatch, rejectWithValue, getState }) => {
    const {
      segment: { query, selectedSegment },
    } = getState() as StoreStateType
    dispatch(setIsLoading(true))
    const params: GetSegmentListRequestType['params'] = {}
    if (query.cursor) {
      params.cursor = query.cursor
    }
    if (query.direction) {
      params.direction = query.direction
    }
    if (query.name) {
      params.name = query.name
    }
    try {
      const { data } = await getSegmentList({ params: { limit: query.limit, ...params } })

      dispatch(setQuery({ pagination: data.pagination }))
      dispatch(
        setSegments(
          data.data.map((segment) => ({
            ...segment,
            is_checked: selectedSegment.some(
              (selected) => selected.segment_id === segment.segment_id,
            ),
          })),
        ),
      )

      dispatch(setIsLoading(false))

      return data
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const updateStatusSegment = createAsyncThunk(
  `${SLICE_NAME}/updateStatusSegment`,
  async (payload: PutUpdateStatusSegmentRequestType, { rejectWithValue }) => {
    try {
      const { data } = await putUpdateStatusSegment(payload)

      if (!data.error.status) {
        toastSuccess('Segment status updated successfully')
      }
      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const removeSegment = createAsyncThunk(
  `${SLICE_NAME}/removeSegment`,
  async (payload: DeleteSegmentRequestType, { rejectWithValue }) => {
    try {
      const { data } = await deleteSegment(payload)

      toastSuccess(data.data.message)
      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const creaeteSegmentGroup = createAsyncThunk(
  `${SLICE_NAME}/creaeteSegmentGroup`,
  async (payload: PostCreateSegmentGroupRequestType, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))

    try {
      const { data } = await postCreateSegmentGroup(payload)

      dispatch(setIsLoading(false))

      toastSuccess(data.data.message)
      return data
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchSegmentGroupList = createAsyncThunk(
  `${SLICE_NAME}/fetchSegmentGroupList`,
  async (_, { dispatch, rejectWithValue, getState }) => {
    dispatch(setIsLoading(true))
    const {
      segment: { query },
    } = getState() as StoreStateType
    dispatch(setIsLoading(true))
    const params: GetSegmentListRequestType['params'] = {}
    if (query.cursor) {
      params.cursor = query.cursor
    }
    if (query.direction) {
      params.direction = query.direction
    }
    if (query.name) {
      params.name = query.name
    }
    try {
      const { data } = await getSegmentGroupList({ params: { limit: query.limit, ...params } })

      dispatch(setQuery({ pagination: data.pagination }))
      dispatch(setSegmentGroups(data.data))
      dispatch(setIsLoading(false))

      return data
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const updateStatusSegmentGroup = createAsyncThunk(
  `${SLICE_NAME}/updateStatusSegmentGroup`,
  async (payload: PutUpdateStatusSegmentGroupRequestType, { rejectWithValue }) => {
    try {
      const { data } = await putUpdateStatusSegmentGroup(payload)

      if (!data.error.status) {
        toastSuccess('Segment Group status updated successfully')
      }
      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const removeSegmentGroup = createAsyncThunk(
  `${SLICE_NAME}/removeSegmentGroup`,
  async (payload: DeleteSegmentGroupRequestType, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))

    try {
      const { data } = await deleteSegmentGroup(payload)

      dispatch(setIsLoading(false))

      toastSuccess(data.data.message)
      return data
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchSegmentGroupABList = createAsyncThunk(
  `${SLICE_NAME}/fetchSegmentGroupABList`,
  async (_, { dispatch, rejectWithValue, getState }) => {
    dispatch(setIsLoading(true))
    const {
      segment: { query },
    } = getState() as StoreStateType
    dispatch(setIsLoading(true))
    const params: GetSegmentListRequestType['params'] = {}
    if (query.cursor) {
      params.cursor = query.cursor
    }
    if (query.direction) {
      params.direction = query.direction
    }
    if (query.name) {
      params.name = query.name
    }
    try {
      const { data } = await getSegmentGroupAB({ params: { limit: query.limit, ...params } })

      dispatch(setQuery({ pagination: data.pagination }))
      dispatch(setSegmentGroupsAB(data.data))
      dispatch(setIsLoading(false))

      return data
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const updateStatusSegmentGroupAB = createAsyncThunk(
  `${SLICE_NAME}/updateStatusSegmentGroupAB`,
  async (payload: PutUpdateStatusSegmentGroupABRequestType, { rejectWithValue }) => {
    try {
      const { data } = await putUpdateStatusSegmentGroupAB(payload)

      if (data.data.message) {
        toastSuccess(data.data.message)
      }

      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const removeSegmentGroupAB = createAsyncThunk(
  `${SLICE_NAME}/removeSegmentGroupAB`,
  async (payload: DeleteSegmentGroupABRequestType, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))

    try {
      const { data } = await deleteSegmentGroupAB(payload)

      dispatch(setIsLoading(false))

      toastSuccess(data.data.message)
      return data
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const fetchSegmentListForGroup = createAsyncThunk(
  `${SLICE_NAME}/fetchSegmentListForGroup`,
  async (name: string, { dispatch, rejectWithValue }) => {
    dispatch(setIsLoading(true))

    try {
      const { data } = await getSegmentList({ params: { limit: 20, name } })

      dispatch(setIsLoading(false))

      return data.data
    } catch (error) {
      dispatch(setIsLoading(false))
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)

export const updateSegmentGroup = createAsyncThunk(
  `${SLICE_NAME}/updateSegmentGroup`,
  async (payload: PutUpdateSegmentGroupType, { rejectWithValue }) => {
    try {
      const { data } = await putUpdateSegmentGroup(payload)

      if (data.data.message) {
        toastSuccess(data.data.message)
      }

      return data
    } catch (error) {
      callErrorMsg(error)
      return rejectWithValue(error)
    }
  },
)
